module.exports = __webpack_public_path__ + "img/circle-plus.60c5b941.svg";